import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'answerCard.correctionUploadAnswerCardModal.title',
    defaultMessage: 'ANSWER CARD UPLOAD',
  },
  cancel: {
    id: 'answerCard.correctionUploadAnswerCardModal.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'answerCard.correctionUploadAnswerCardModal.continue',
    defaultMessage: 'Continue',
  },
  dragDrop: {
    id: 'answerCard.addClassModal.dragDrop',
    defaultMessage: 'Drag the file here',
  },
  clickHere: {
    id: 'answerCard.addClassModal.clickHere',
    defaultMessage: 'or click here',
  },
});
